import * as React from "react";
const SvgCountMinusIcon = () => (
  <svg width={20} height={3} fill="none">
    <path fill="#4338CA" d="M19.95 0v2.95H.5V0h19.45Z" />
  </svg>
);
export default SvgCountMinusIcon;
